import pdfMake from 'pdfmake/build/pdfmake.js';
import moment from 'moment';
import ReportsAPI from './../../../Reports/api/reports_api';

const getUser = async (id) => {
  return new Promise((resolve, reject) => {
    const dataToSend = { id_usuario: id };
    fetch(process.env.REACT_APP_PUBLIC_URL + 'usuario/consultar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(dataToSend)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {

        resolve(data.contenido[0]);

      }).catch((error) => {
        console.error('Error:', error);
        reject(error);
      });
  });
}


const getBase64ImageFromURL = (url) => {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.setAttribute("crossOrigin", "anonymous");

    img.onload = () => {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      var dataURL = canvas.toDataURL("image/png");

      resolve(dataURL);
    };

    img.onerror = error => {
      reject(error);
    };

    img.src = url;
  });
}

const loadPlan = async (billing) => {
  return new Promise((resolve, reject) => {
  var dataClose = { id_plan: billing.id_plan };
    fetch(process.env.REACT_APP_PUBLIC_URL + 'plan/consultar_plan', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(dataClose)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        resolve(data.contenido[0]);
      }).catch((e) => {
        console.log(e);
      });
  });
}

export const printRecipt = async (billing,details) => {
  const user = JSON.parse(sessionStorage.getItem('usuario'));
  const profile = JSON.parse(sessionStorage.getItem('clinica'));
  const plan = await loadPlan(billing);
  const userReceipt = await getUser(billing.usuario);

  const today = moment(new Date()).format('MMMM Do YYYY');
  const hour = moment(billing.fecha).format('h:mm a');
  const fechaFac = moment(billing.fecha).format('MMMM Do YYYY');

  const city = profile.direccion.id_ciudad;
  const dept =  profile.direccion.id_dpto;
  const getCity = await ReportsAPI.loadCity(city);
  const getDepts = await ReportsAPI.loadDepartment();
  const deptoProfile = getDepts.find((depto) => depto.id === dept);
  const third = await ReportsAPI.loadThird(billing.id_tercero);
  console.log("location", getCity, deptoProfile);

  let procedures = '';

  try {
    for (let k = 0; k < billing.servicios.servicios.length; k++) {
      procedures = procedures + billing.servicios.servicios[k].codigo +': '+billing.servicios.servicios[k].nombre + '\n'
    }
  } catch (error) {
    console.log(error)
  }

  let estado_recibo = billing.recibo_cancelado == true ? "ANULADO" : "RECIBIDO";

  const documentDefinition = {
    pageSize: 'LETTER',
    pageOrientation: 'portrait',
    content: [
      {
        margin: [40, 10, 0, 0],
        layout: 'noBorders',
        table: {
          widths: ['*', '*', 120],
          body: [
            [{
              image: await getBase64ImageFromURL(process.env.REACT_APP_PUBLIC_URL + "clinica/" + profile.id_clinica + "/logo/" + sessionStorage.getItem('token')),
              fit: [100, 50],
            },
            { text: profile.nombre + ' \n Nit. ' + profile.nit + ' \n Teléfonos: ' + profile.telefono1 + '-' + profile.telefono2 + ' ' + profile.direccion.direccion, style: 'head' },
            { text: 'Recibo de caja \n No. ' + billing.num_recibo + '\n' +estado_recibo, style: 'head' }/*,
            { text: billing.recibo_cancelado == true ? "ANULADO" : "RECIBIDO", style: 'head' }   */
          ],
          ]
        },
      },
      {
        margin: [0, 30, 0, 0],
        table: {
          widths: ['*'],
          body: [
            [{ text: 'Fecha: '+ getCity[0].ciunom +', '+ fechaFac  + ', Hora: ' +  hour, style: 'textStyle' }],
          ]
        },
      },
      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [168, '*'],
          body: [
            [{ text: 'Recibido de ', style: 'textStyle' }, { text: details.tip_documento + '-' + details.num_documento + ' ' + details.fullname, style: 'textStyle' }],
            [{ text: 'Cliente ', style: 'textStyle' }, {
              text: plan.tipo == 1 ? 'Particular - ' + third.nombre :
                plan.tipo == 2 ? 'Subsidiado - ' + third.nombre :
                  plan.tipo == 3 ? 'Contributivo - ' + third.nombre :
                    plan.tipo == 4 ? 'Regimen Especial - ' : '' + third.nombre, style: 'textStyle'
            }],
            [{ text: 'Paciente ', style: 'textStyle' }, { text: details.tip_documento + '-' + details.num_documento + ' ' + details.fullname, style: 'textStyle' }],
            [{ text: 'Valor ', style: 'textStyle' }, { text: '$' + billing.total + ' Forma de Pago: ' + billing.forma_pago, style: 'textStyle' }],
            [{ text: 'Por Concepto de ', style: 'textStyle' }, { text: procedures, style: 'textStyle' }],
          ]
        },
      },
      {
        columns: [
          {
            // auto-sized columns have their widths based on their content                                       
            margin: [40, 60, 25, 0],
            layout: 'noBorders',
            table: {
              widths: [110],
              headerRows: 1,
              body: [
                [{ text: '' }],
                [{ text: 'Cajero ' + userReceipt.nombres + ' ' + userReceipt.apellido1, style: 'foot', }],
    
              ]
            },
          },
          {
            // auto-sized columns have their widths based on their content                                       
            margin: [40, 60, 25, 0],
            layout: 'headerLineOnly',
            table: {
              widths: [110],
              headerRows: 1,
              body: [
                [{ text: '' }],
                [{ text: profile.nombre + ' \n Nit. ' + profile.nit, style: 'foot', }],
    
              ]
            },
          },
        ]
    },
      {
        margin: [0, 10, 0, 0],
        text: 'Usuario y fecha de impresión ' + user.nombre + ' - ' + today, style: 'foot',
      },
    ],
    styles: {
      head: {
        fontSize: 8,
        alignment: 'center'
      },
      textStyle: {
        fontSize: 10,
      },
      foot: {
        fontSize: 7
      }
    }
  }

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.getDataUrl(function (outDoc) {
    document.getElementById('pdfV').src = outDoc;
  });
}